import { SystemError } from "@ascend-ltd/accounts-core";
import { initializeEnvironmentValue } from "./utils/environment-initializer";

export type EnvironmentTypeLiterals = "local" | "development" | "production";

const checkEnv = (key: string, value: string | undefined): string => {
  if (value === undefined) {
    throw new SystemError.Unexpected(
      `environment value ${key} doesn't set yet.`
    );
  }
  return value;
};

type ServerConfig = {
  baseUrl: string;
};

type AuthConfig = {
  accountUrl: string;
  publicKeyUrl: string;
  issuer: string;
  allowOrigins: string[];
};

type Config = {
  env: EnvironmentTypeLiterals;
  tag: string;
  auth: AuthConfig;
  server: ServerConfig;
};

export const CurrentConfig: Config = {
  env: initializeEnvironmentValue(
    checkEnv("NEXT_PUBLIC_ENVIRONMENT", process.env.NEXT_PUBLIC_ENVIRONMENT)
  ),
  tag: initializeEnvironmentValue(
    checkEnv("NEXT_PUBLIC_RELEASE_TAG", process.env.NEXT_PUBLIC_RELEASE_TAG)
  ),
  auth: {
    accountUrl: checkEnv(
      "NEXT_PUBLIC_NEXT_PUBLIC_AUTH_ASCEND_ACCOUNT_URL",
      process.env.NEXT_PUBLIC_AUTH_ASCEND_ACCOUNT_URL
    ),
    publicKeyUrl: `https://cognito-idp.${checkEnv(
      "NEXT_PUBLIC_USER_POOL_REGION",
      process.env.NEXT_PUBLIC_USER_POOL_REGION
    )}.amazonaws.com/${checkEnv(
      "NEXT_PUBLIC_USER_POOL_ID",
      process.env.NEXT_PUBLIC_USER_POOL_ID
    )}/.well-known/jwks.json`,
    issuer: `https://cognito-idp.${checkEnv(
      "NEXT_PUBLIC_USER_POOL_REGION",
      process.env.NEXT_PUBLIC_USER_POOL_REGION
    )}.amazonaws.com/${checkEnv(
      "NEXT_PUBLIC_USER_POOL_ID",
      process.env.NEXT_PUBLIC_USER_POOL_ID
    )}`,
    allowOrigins: checkEnv(
      "NEXT_PUBLIC_AUTH_ALLOW_ORIGINS",
      process.env.NEXT_PUBLIC_AUTH_ALLOW_ORIGINS
    ).split(","),
  },
  server: {
    baseUrl: checkEnv(
      "NEXT_PUBLIC_API_BASE_URL",
      process.env.NEXT_PUBLIC_API_BASE_URL
    ),
  },
};
